import classes from './Advantages.module.css';

const Advantages = () => {
  return (
    <aside className={classes.advantagesContainer}>
      <p className={classes.title}>
        Ventajas de enseñar con Mayahii
      </p>
      <div className={classes.advantageSection}>
        <p className={classes.advantageText}>Plataforma escalable</p>
        <figure className={classes.advantageImg}>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/plataformaEscalable.jpg"
            alt=""
            className={classes.img}
          />
        </figure>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            Crea tu Academia en minutos, brindando una atractiva
            experiencia educativa a tus alumnos.
          </li>
          <li className={classes.listItem}>
            Personalizable con la imagen de tu marca.
          </li>
          <li className={classes.listItem}>
            Sin límite de usuarios.
          </li>
          <li className={classes.listItem}>Sin límite de cursos.</li>
        </ul>
      </div>
      <div className={classes.advantageSection}>
        <p className={classes.advantageText}>Fácil de administrar</p>
        <figure className={classes.advantageImg}>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/facilAdministrar.jpg"
            alt=""
            className={classes.img}
          />
        </figure>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            Crea y sube tus contenidos rápidamente.
          </li>
          <li className={classes.listItem}>
            Anexa a tus cursos documentos y archivos en cualquier
            formato.
          </li>
        </ul>
      </div>
      <div className={classes.advantageSection}>
        <p className={classes.advantageText}>Paga lo que consumes</p>
        <figure className={classes.advantageImg}>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/pagaConsumes.jpg"
            alt=""
            className={classes.img}
          />
        </figure>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            Paga solo por lo que utilices, durante el tiempo que lo
            necesites, sin contratos de largo plazo ni
            licenciamientos complejos. No hay cargos adicionales ni
            tarifas de terminación.
          </li>
        </ul>
      </div>
      <div className={classes.advantageSection}>
        <p className={classes.advantageText}>Simple de Monitorear</p>
        <figure className={classes.advantageImg}>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/simpleMonitorear.jpg"
            alt=""
            className={classes.img}
          />
        </figure>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            Basada en la nube, sin requerimientos especiales de
            hardware o software.
          </li>
          <li className={classes.listItem}>
            Recibe apoyo y acompañamiento técnico para administrar tu
            academia.
          </li>
        </ul>
      </div>
      <div className={classes.advantageSection}>
        <p className={classes.advantageText}>
          Gran experiencia de usuario
        </p>
        <figure className={classes.advantageImg}>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/experienciaUsuario.jpg"
            alt=""
            className={classes.img}
          />
        </figure>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            Vive un gran experiencia de usuario con enseñanza basada
            en video.
          </li>
          <li className={classes.listItem}>
            Emite automáticamente tus propios diplomas y constancias
            para los usuarios que terminen sus cursos.
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Advantages;
